import {ADD_TO_CART, ADD_TO_CART_SUCCESS, TIME_RENEWAL, TIME_RENEWAL_SUCCESS, REMOVE_ITEM_FROM_CART, REMOVE_ITEM_FROM_CART_SUCCESS, REMOVE_ALL_ITEMS_FROM_CART, REMOVE_ALL_ITEMS_FROM_CART_SUCCESS} from '../ReduxActions/CartActions.js'

const initialState = {
  items: [],
  totalPrice: 0,
  addToCartSuccess: undefined
}

//@TODO create add to cart success change to undefined

const Cart = (state = initialState, action) => {
  switch(action.type) {
    case ADD_TO_CART:
      return {
        ...state,
        addToCartSuccess: undefined
      }
    
    case ADD_TO_CART_SUCCESS:
      let item = action.item;
      item['cartItemId'] = action.cartItemId;
      let date = action.date;
      return {
        // ...state, // @TODO Might need to delete this
        items: state.items ? [...state.items, item] : [item],
        totalPrice: state.totalPrice ? state.totalPrice + item.price : item.price, // @TODO add the price
        date: state.date ? state.date : date,
        addToCartSuccess: true
      }

    case TIME_RENEWAL:
      return {
        ...state
      }
    
    case TIME_RENEWAL_SUCCESS:
      return {
        items: state.items,
        totalPrice: state.totalPrice,
        date: new Date()
      }
    
    case REMOVE_ITEM_FROM_CART:
      return {
        ...state
      }
    
    case REMOVE_ITEM_FROM_CART_SUCCESS:
      return {
        // ...state,
        totalPrice: state.totalPrice - action.price,
        items: state.items.filter(item => item.cartItemId !== action.cartItemId),
        
      }
    
    case REMOVE_ALL_ITEMS_FROM_CART:
      return {
        ...state
      }
    
    case REMOVE_ALL_ITEMS_FROM_CART_SUCCESS:
      return {
        initialState
      }

    default:
      return state;
  }
}

export default Cart;